// extracted by mini-css-extract-plugin
module.exports = {"sectionItem":"PageCourseSectionList__sectionItem__3rn10","title":"PageCourseSectionList__title__33y5u","progress":"PageCourseSectionList__progress__bDjv5"};